import React, { useEffect, useRef, useState } from "react"
import { FaRegClock } from "react-icons/fa"
import { useSelector } from "react-redux"

import FssShiftStartMessage from "./FssShiftStartMessage"
import { ShiftCashierStart } from "components"
import FssCashierBranches from "./FssCashierBranches"
import classes from "./index.module.scss"

const FoodsStartShift = () => {
  const unmount = useRef(false)

  const { _id: accountId, cashierBranches } =
    useSelector(state => state.userAccountInfo)

  const [content, setContent] = useState("cashierBranches")
  const [selectedBranch, setSelectedBranch] = useState(null)

  const setInitialCashierBranch = async () => {
    if (cashierBranches.length === 1) {
      const cashierBranch = cashierBranches[0]

      setSelectedBranch({
        label: cashierBranch.name,
        value: cashierBranch.branchId
      })

      return
    }

    const json =
      localStorage.getItem("defaultCashiersBranch") || "{}"

    const defaultCashiersBranch =
      JSON.parse(json)

    const defaultCashierBranch =
      defaultCashiersBranch[accountId]

    !!defaultCashierBranch &&
      setSelectedBranch(defaultCashierBranch)
  }

  useEffect(() => {
    setInitialCashierBranch()
  }, [cashierBranches])

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  if (content === "startShiftPage") {
    return <ShiftCashierStart setContent={setContent} />
  }

  return (
    <div className={classes["container"]}>
      <FaRegClock
        className={classes["icon"]}
      />

      {
        content === "cashierBranches" &&
        <FssCashierBranches
          setContent={setContent}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
        />
      }

      {
        content === "startShift" &&
        <FssShiftStartMessage
          setContent={setContent}
        />
      }
    </div>
  )
}

export default FoodsStartShift